export interface AddressValidationCacheEntry {
  status: boolean;
  matchCode?: string;
  enforce?: boolean;
  postalAddress?: {
    addressLines: string[];
    administrativeArea: string;
    postalCode: string;
    locality: string;
  };
  [key: string]: unknown;
}

export const normalizeAddressValue = (value?: string): string =>
  typeof value === 'string' ? value.replace(/\s+/g, ' ').trim() : '';

export const buildAddressValidationCacheKey = (
  values: Array<string | undefined>
): string => values.map(normalizeAddressValue).join('|');

export class AddressValidationCache {
  private readonly entries = new Map<string, AddressValidationCacheEntry>();

  get(key: string): AddressValidationCacheEntry | undefined {
    return this.entries.get(key);
  }

  set(key: string, value: AddressValidationCacheEntry): void {
    this.entries.set(key, value);
  }
}
